export default class Header {
	constructor() {
		this.headerEl = document.getElementById("wrapper-navbar");
		this.isWorking = false;

		this.body = document.body;
		this.debounce_timer = null;

		this.scrollOffset = 0;

		this.events();
	}

	setStickyHeader() {
		this.isWorking = true;
		this.body.classList.add("has-sticky-header");
		this.isWorking = false;
	}

	unsetStickyHeader() {
		this.isWorking = true;
		this.body.classList.remove("has-sticky-header");
		this.isWorking = false;
	}

	onScroll() {
		if (this.debounce_timer) {
			window.clearTimeout(this.debounce_timer);
		}

		this.debounce_timer = window.setTimeout(() => {
			if (this.isWorking) return;

			let pageYOffset = window.pageYOffset || document.body.scrollTop;

			// https://stackoverflow.com/a/45719399
			if (this.scrollOffset > pageYOffset) {
				// Scrolling up
				if (100 >= pageYOffset) {
					this.unsetStickyHeader();
				}
			} else {
				// Scrolling down
				if (100 < pageYOffset) {
					this.setStickyHeader();
				}
			}

			this.scrollOffset = pageYOffset;
		}, 50);
	}

	events() {
		window.addEventListener("scroll", this.onScroll.bind(this), false);
	}
}
